export enum ResultType {
  ValueValue = 1,
  GreaterEqualValue = 2,
  LessEqualValue = 4,
  GreaterThanValue = 8,
  LessThanValue = 16, // 0x00000010
  AlphaResults = 32, // 0x00000020
  Microbiology = 64, // 0x00000040
  AlphaMicrobiology = 128, // 0x00000080
  OpenResultWithoutUnit = 256, // 0x00000100
  OpenResultWithUnit = 512, // 0x00000200
  SpecificCutOff = 1024, // 0x00000400
  Titer = 2048, // 0x00000800
  None = 4096, // 0x00001000
}
